import { FC, ReactNode } from 'react';
import { Range } from '../BarChart/BarChart.types';

interface Props {
  length: number;
  renderValue: (value: number) => ReactNode | string;
  range: Range;
  isPrimary: boolean;
}

export const BarChartScaleText: FC<Props> = ({
  length,
  renderValue,
  range,
  isPrimary,
}) => {
  const cn = 'bar-chart-scale__label';
  const cnPrimary = `${cn}--primary`;
  const cnSecondary = `${cn}--secondary`;
  const className = `${cn} ${isPrimary ? cnPrimary : cnSecondary}`;
  return (
    <div className="bar-chart-scale">
      <div className={`${className} ${cn}--start`}>
        {range.min !== 0 ? renderValue(range.min) : 0}
      </div>
      {Array.from({ length }, (_, i) => {
        const reversedIndex = length - i;
        return (
          <div
            key={i}
            className={className}
            style={{
              top: `${(i / length) * 100}%`,
            }}
          >
            {renderValue(reversedIndex * range.step)}
          </div>
        );
      })}
    </div>
  );
};
